import { useAppSelector } from 'src/utils/hooks';
import { Box, useMediaQuery, useTheme } from '@mui/material';

interface RequireContext {
  keys(): string[];
  <T>(id: string): T;
  resolve(id: string): string;
}

const logosContext: RequireContext = (require as any).context(
  '../../public/logos/',
  false,
  /\.(png|jpe?g|svg)$/
);

const logos: Record<string, string> = logosContext
  .keys()
  .reduce((acc: Record<string, string>, logoPath: string) => {
    const filename = logoPath.replace('./', '');
    const key = filename.split('.')[0];
    acc[key] = filename;
    return acc;
  }, {});

export function HomeIcon() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const ismd = useMediaQuery(theme.breakpoints.down('md'));

  const { mandant, logo, isColorBlindMode } = useAppSelector(
    (state) => state?.config
  );

  const effectiveLogoKey =
    (mandant as string) === 'sdk' && isColorBlindMode
      ? 'sdkColorBlind'
      : mandant;

  const isValidLogo = effectiveLogoKey && logos[effectiveLogoKey];
  const flexPosition: Record<string, string> = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };
  const logoSize = isXs ? 60 : ismd ? 30 : Number(logo.size);

  return isValidLogo ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: flexPosition[logo.position],
      }}
    >
      {(mandant as string) === 'sdk' && isColorBlindMode ? (
        <Box
          sx={{
            position: 'relative',
            width: {
              xs: '160px',
              sm: '180px',
              md: '197px',
            },
            height: {
              xs: '80px',
              sm: '85px',
              md: '89px',
            },
            margin: {
              xs: '12px 12px 16px 0px',
              sm: '14px 16px 18px 1px',
              md: '16px 20px 20px 1px',
            },
          }}
        >
          <Box
            component="img"
            src={`${window.location.origin}/logos/${logos[effectiveLogoKey]}`}
            alt="Logo"
            sx={{
              position: 'absolute',
              top: '14px',
              left: '0px',
              width: ismd ? '100px' : '120px',
              height: 'auto',
            }}
          />

          <Box
            component="span"
            sx={{
              position: 'absolute',
              top: {
                xs: '65px',
                sm: '68px',
                md: '72px',
              },
              left: {
                xs: '4px',
                sm: '5px',
              },
              width: {
                xs: '150px',
                sm: '170px',
                md: '189px',
              },
              fontSize: {
                xs: '12px',
                sm: '13px',
                md: '14px',
              },
              fontWeight: 600,
              color: 'text.primary',
              lineHeight: '12px',
            }}
          >
            Einfach für Ihr Leben da.
          </Box>
        </Box>
      ) : (
        <img
          src={`${window.location.origin}/logos/${logos[effectiveLogoKey]}`}
          height={`${logoSize}%`}
          width={`${logoSize}%`}
          alt="Logo"
          style={{
            margin: '20px',
          }}
        />
      )}
    </Box>
  ) : null;
}
